import {
  HomeOutlined,
  EditOutlined,
  CodeSandboxOutlined,
  CloudSyncOutlined,
  ShopOutlined,
  ProfileOutlined,
  DashboardOutlined,
  FileTextFilled
} from '@ant-design/icons';
import * as React from 'react';

const menu = [
  {
    path: '/',
    name: '首页',
    icon: <HomeOutlined />,
  },
  {
    path: '/Example',
    name: '示例',
    icon: <CodeSandboxOutlined />,
  },
  {
    name: '商品',
    icon: <ShopOutlined />,
    children: [
      {
        name: '海外仓商品',
        children: [
          {
            name: '注册商品',
            path: '/MerchandiseInfo/batchAdd'
          },
          {
            name: '商品信息',
            path: '/MerchandiseInfo/info'
          },
          {
            name: '批量打印条码',
            path: '/BatchPrintBarcodes/index'
          },
          {
            name: '组套商品关系管理',
            path: '/PackageManagement/index'
          },
          {
            name: '投保商品管理',
            path: '/InsuranceSkuManage/index'
          },
          {
            name: '商品分组管理',
            path: '/SkuGroupClassManange/index'
          },
          {
            name: 'TiktokFBT商品关联',
            path: '/TiktokFbtProductLink/index'
          },
          {
            name: '尺寸重量变更重算',
            path: '/WeightChange/index'
          }
        ]
      },
      {
        name: '商品合规信息管理',
        children: [
          {
            name: 'GPSR信息维护',
            path: '/EuProxy/index'
          },
          {
            name: '文件管理',
            path: '/FileManagement/index'
          },
          {
            name: 'WEEE信息维护',
            path: '/WEEEInformation/weeeInfo'
          }
        ]
      }
    ]
  },
  {
    name: '库存',
    icon: <ShopOutlined />,
    children: [
      {
        name: '库存管理',
        children: [
          {
            name: '海外仓库存',
            path: '/Australia/index'
          },
          {
            name: '分类库存',
            path: '/Australia/batchInventory'
          },
          {
            name: '货权转移列表',
            path: '/CargoTransfer/index'
          },
          {
            name: '异常库存明细',
            path: '/AbnormalInventoryDetails/index'
          },
          {
            name: 'VAT失效禁售库存明细',
            path: '/InvalidInventory/index'
          },
          {
            name: '异动库存确认',
            path: '/AbnormalModificationInventory/index'
          },
          {
            name: '库存流水',
            path: '/Australia/inventoryFlow'
          },
          {
            name: '库龄分析明细',
            path: '/Australia/libraryAgeAnalysis'
          }
        ]
      },
      {
        name: '组织库存管理',
        children: [
          {
            name: '组织库存',
            path: '/OrgInventory/index'
          },
          {
            name: '组织库存变更记录',
            path: '/OrgInventory/changeRecord'
          },
          {
            name: '组织库存调整',
            path: '/OrgInventory/adjust'
          },
          {
            name: '组织管理',
            path: '/OrgInventory/organization'
          },
          {
            name: '分配策略',
            path: '/OrgInventory/strategy'
          },
          {
            name: '组织库存初始化',
            path: '/OrgInventory/init'
          }
        ]
      },
      {
        name: '仓储单管理',
        children: [
          {
            name: '仓储单',
            path: '/StorageTollList/index'
          },
          {
            name: '仓储单明细',
            path: '/StorageTollListDetail/index'
          },
        ]
      },
      {
        name: '单品条码管理',
        children: [
          {
            name: '单品条码查询',
            path: '/QueryTtemBarcode/index'
          },
          {
            name: '单品条码导入',
            path: '/ImportTtemBarcode/index'
          }
        ]
      },
      {
        name: 'Owner库存管理',
        children: [
          {
            name: 'Owner库存查询',
            path: '/OwnerStockQuery/index'
          },
          {
            name: 'Owner交易明细',
            path: '/TransactionDetails/index'
          },
          {
            name: '在库库存初始化',
            path: '/InitializeIibraryInventory/index'
          },
        ]
      },
    ]
  },
  {
    name: '海外仓',
    icon: <CloudSyncOutlined />,
    children: [
      {
        name: '海外仓出库',
        children: [
          {
            name: '全部订单',
            path: '/WHOutbound/index'
          },
          {
            name: '批量处理结果',
            path: '/WHOutbound/batchResult'
          },
          {
            name: '费用计算器',
            path: '/WHOutbound/priceTools'
          },
          {
            name: '创建出库单',
            path: '/WHOutbound/createOrder'
          },
          {
            name: '批量上传',
            path: '/WHOutbound/batchImport'
          },
          {
            name: '智能推荐日志',
            path: '/WHOutbound/intelligentRecommendedLogInfo'
          },
          {
            name: '缺量订单处理',
            path: '/ShortOrder/index'
          },
          {
            name: '订单处理',
            path: '/PickupProcessing/index'
          },
          {
            name: '补充信息',
            path: '/WHOutbound/supplementaryInfo'
          },
          {
            name: '分批处理订单',
            path: '/WHOutbound/processOrdersInBatches'
          },
          {
            name: '复合打包测算',
            path: '/WHOutbound/packageCalculate'
          },
        ]
      },
      {
        name: '统计视图及工具',
        children: [
          {
            name: '出库及时率',
            path: '/OutboundOnTime/index',
          },
          {
            name: '入库及时率',
            path: '/InboundOntime/index',
          },
          {
            name: '邮编查询工具',
            path: '/QueryPostCode/index',
          },
          {
            name: '电商清关计算器',
            path: '/EcommerceCalculator/index'
          },
          {
            name: '分仓比例测算工具',
            path: '/PartitionEstimation/index'
          },
          {
            name: '仓配指标',
            path: '/WarehouseAllocationIndicator/index'
          },
        ]
      },
      {
        name: '海外仓入库',
        children: [
          {
            name: '新增入库单',
            path: '/WHInbound/CreateOrder'
          },
          {
            name: '全部订单',
            path: '/WHInbound/info'
          },
          {
            name: '预约单管理',
            path: '/BookingOrder/index'
          },
          {
            name: '第三方预约单',
            path: '/BookingOrder/thirdParty'
          },
          {
            name: '快递卸货记录查询',
            path: '/ExpressOrder/index'
          },
          {
            name: '商品尺重抽验服务单查询',
            path: '/SizeWeightInspection/index'
          },
          {
            name: '入库限制查询',
            path: '/WhinboundLimit/index'
          },
          {
            name: '运输资料管理',
            path: '/WhinboundFileManage/index'
          },
          {
            name: '头程运输单',
            path: '/GtpOrder/index'
          },
        ]
      },
      {
        name: 'LMA',
        children: [
          {
            name: 'LMA全部订单',
            path: '/ThirdOutbound/index'
          },
          {
            name: '批量上传',
            path: '/ThirdOutbound/BatchImport'
          },
          {
            name: '导入失败订单',
            path: '/ThirdOutbound/FailedOrder'
          },
          {
            name: '大小包关系管理',
            path: '/ThirdOutbound/packageRelation'
          },
        ]
      },
      {
        name: '库内',
        children: [
          {
            name: '创建增值订单',
            path: '/VasOrder/createOrder'
          },
          {
            name: '创建库内增值单',
            path: '/VasOrder/createInstockOrder'
          },
          {
            name: '全部库内订单',
            path: '/AllWarehouseOrders/info'
          },
          {
            name: 'PVA押金冻结管理',
            path: '/DepositFreezeManagement/index',
          },
          {
            name: 'PVA入库明细跟踪',
            path: '/InboundDetailsTracking/index'
          },
        ]
      },
      {
        name: '异常管理',
        children: [
          {
            name: '异常单',
            path: '/ExceptionDetails/index'
          },
        ]
      },
      {
        name: '增值管理',
        children: [
          {
            name: '增值订单',
            path: '/VasOrder/info'
          },
        ]
      },
    ],
  },
  {
    name: '平台同步',
    icon: <CloudSyncOutlined />,
    children: [
      {
        name: '账号管理',
        children: [
          {
            name: '店铺授权',
            path: '/EbayAccount/index',
          }
        ]
      },
      {
        name: '规则管理',
        children: [
          {
            name: '订单处理规则',
            path: '/SynSwitch/index',
          },
          {
            name: '自动发货规则',
            path: '/AutoRulesSetting/index',
          },
          {
            name: '自动退货规则',
            path: '/AutoReturnRule/index',
          },
        ]
      },
      {
        name: '商品&库存管理',
        children: [
          {
            name: 'ebay 认证仓商品绑定',
            path: '/EbayCertifiedSku/create',
          },
          {
            name: 'ebay 认证仓商品推送',
            path: '/EbayCertifiedSku/index',
          },
        ]
      },
      {
        name: '发货订单',
        children: [
          {
            name: '发货订单',
            path: '/ShippingOrder/index',
          },
        ]
      },
      {
        name: '平台活动',
        children: [
          {
            name: 'AliExpress海外托管专享库存',
            path: '/InventoryLockConfig/index',
          },
        ]
      },
    ]
  },
  {
    name: '退货',
    icon: <CloudSyncOutlined />,
    children: [
      {
        name: '退货管理',
        children: [
          {
            name: '快速退货',
            path: '/ReturnOrders/quickReturn',
          },
          {
            name: '创建退货单',
            path: '/ReturnOrders/stepOneNewWH',
          },
          {
            name:'批量创建退货单',
            path: '/ReturnOrders/batchImport',
          },
          {
            name: '退货全部订单',
            path: '/ReturnOrders/index',
          },
          {
            name: '退货暂存处理',
            path: '/ReturnOrders/returnSkuProcess',
          },
          {
            name: '退货轨迹查询',
            path: '/ReturnOrders/queryTracking',
          },
        ]
      },
      {
        name: '退货商品',
        children: [
          {
            name: '检查上架标准维护',
            path: '/WinitCheckQuality/index',
          },
          {
            name: '定制拍照模板维护',
            path: '/ReturnPhotographTemplate/index',
          },
          {
            name: '指定不良品混合存储',
            path: '/MixedStorage/index',
          }, {
            name: '退货策略维护',
            path: '/ReturnPolicyMaintenance/index'
          },
          {
            name: '质检方案维护',
            path:'/QualityInspectionPlan/index'
          }
        ]
      },
    ]
  },
  {
    name: '索赔查件',
    icon: <ProfileOutlined />,
    children: [
      {
        name: '代客索赔管理',
        children: [
          {
            name: '申请代客索赔',
            path: '/ClaimAgent/create',
          },
          {
            name: '全部代客索赔',
            path: '/ClaimAgent/index',
          }
        ]
      },
      {
        name: '海外仓索赔管理',
        children: [
          {
            name: '申请标准索赔',
            path: '/ClaimStandard/create',
          },
          {
            name: '全部标准索赔',
            path: '/ClaimStandard/index',
          }
        ]
      },
      {
        name: '海外仓尾程查件',
        children: [
          {
            name: '申请尾程查件',
            path: '/Tracking/create',
          },
          {
            name: '全部尾程查件',
            path: '/Tracking/index',
          }
        ]
      },
      {
        name: '库内查询',
        children: [
          {
            name: '视频查询',
            path: '/Warehouse/video',
          }
        ]
      },
      {
        name: '增值服务管理',
        children: [
          {
            name: '新增增值服务',
            path: '/AddService/create',
          },
          {
            name: '全部增值服务',
            path: '/AddService/index',
          }
        ]
      }
    ]
  },
  {
    name: '个人中心',
    icon: <EditOutlined />,
    children: [
      {
        name: '系统设置',
        children: [
          {
            name: '账号安全',
            path: '/UserCenter/site',
          },
        ]
      },
      {
        name: '当前账号设置',
        children: [
          {
            name: '获取Token',
            path: '/UserCenter/getToken',
          },
        ]
      },
      {
        name: '合同资料管理',
        children: [
          {
            name: '我的资料',
            path: '/UserCenter/userinfo',
          },
          {
            name: '服务与合同',
            path: '/UserCenter/myService',
          },
        ]
      },
      {
        name: '账户组管理',
        children: [
          {
            name: '账户组列表',
            path: '/SubCompany/index',
          },
        ]
      },
      {
        name: '服务设置',
        children: [
          {
            name: '提单收/发货人配置',
            path: '/BillConsignee',
          },
          {
            name: '英国VAT优先级配置',
            path: '/VATPriority',
          },
          {
            name: '地址管理',
            path: '/Address',
          },
          {
            name: '进/出口商管理',
            path: '/IorEor/index',
          },
          {
            name: '偏好设置',
            path: '/UserCenter/preferences',
          },
          {
            name: '申报价值获取设置',
            path: '/UserCenter/declareValueGetSetting',
          },
          {
            name: '地址自动修正配置',
            path: '/Address/autoCorrection',
          },
        ]
      },
      {
        name: '通知与导出中心',
        children: [
          {
            name: '导出中心',
            path: '/ExportCenter/index',
          },
        ]
      },
      {
        name: '消息订阅',
        children: [
          {
            name: '新增订阅',
            path: '/MessageSubscription/addSubscription',
          },
          {
            name: '订阅管理',
            path: '/MessageSubscription/subscriptionManage',
          },
        ]
      },
      {
        name: '卡券与优惠',
        children: [
          {
            name: '礼品卡管理',
            path: '/GiftCard/giftCardManagement',
          },
          {
            name: '海外仓业务激励方案',
            path: '/Experience/standardScheme',
          },
        ]
      },
      {
        name: '反馈与建议',
        children: [
          {
            name: '功能建议',
            path: '/Feedback/features',
          }
        ]
      },
    ]
  },
  {
    name: '数据中心',
    icon: <DashboardOutlined />,
    children: [
      {
        name: '报表分析',
        children: [
          {
            name: '动销健康度分析指标',
            path: '/TurnoverHealth/index'
          }
        ]
      }
    ]
  },
  {
    name: '平台入驻',
    icon: <FileTextFilled />,
    children: [
      {
        name: '平台入驻1',
        children: [
          {
            name: '入驻申请',
            path: '/SettledApply/index'
          },
          {
            name: '入驻进度查看',
            path: '/SettlementProgress/index'
          }
        ]
      }
    ]
  },

];

export default menu;
